import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import ChevronDown from 'images/icons/controls/chevron-down.svg?react-svg';
import ChevronUp from 'images/icons/controls/chevron-up.svg?react-svg';
import { RadioList, RadioListItem } from 'scy/RadioList';
import { Tabs, Tab } from 'scy/Tabs';
import {
  selectDeliveryTime,
  selectDeliveryDate
} from 'shared/components/checkoutPage/actions';
import { trackNow } from 'shared/models/analytic';
import checkInView from 'shared/utils/checkInView';
import { PrimaryButton } from 'scy/buttons';
import { uppercase } from 'scy/text/styles.mod.scss';
import { AccentH5, SecondarySmall } from 'scy/text';
import { TextButton } from 'scy/buttons';
import Icon from './Icon';
import Title from './Title';
import { width100, textCenter } from 'scy/utils.mod.scss';
import { flex, centerItems } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';

class Expanded extends React.Component {
  constructor(props) {
    super(props);

    const selectedTab =
      (!_.isEmpty(props.date) && props.date) ||
      (!_.isEmpty((props.availability.dates || [])[0]) &&
        props.availability.dates[0]) ||
      {};

    this.state = {
      slotsExpanded: false,
      selectedTab,
      error: null
    };
  }

  componentDidMount() {
    checkInView(this.form);

    if (_.isEmpty(this.props.slot)) {
      const firstDate = (this.props.availability.dates || [])[0];
      this.selectTab(firstDate);
      if (this.props.availability.immediate_delivery) {
        this.selectSlot({ date: firstDate, slot: this.props.immediateSlot });
      }
    }

    this.trackETA();
  }

  trackETA() {
    const { display, value } = this.props.availability.eta || {};
    if (typeof value !== 'undefined') {
      trackNow('Pre-Checkout ETA', { display, value });
    }
  }

  expandSlots() {
    this.setState({ slotsExpanded: true });
    trackNow('Delivery Times View More Clicked');
  }

  collapseSlots() {
    this.setState({ slotsExpanded: false });
    checkInView(this.form);
    trackNow('Delivery Times View Fewer Clicked');
  }

  selectTab(date) {
    this.setState({ selectedTab: date });
  }

  selectSlot({ slot, date }) {
    this.props.selectDeliveryTime(slot);
    this.props.selectDeliveryDate(date);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (_.isEmpty(this.props.slot)) {
      this.setState({ error: 'Please select a delivery time.' });
      return;
    }
    this.props.collapse();
  }

  dateIsToday({ date }) {
    return moment().format('MM/DD/YYYY') === date;
  }

  render() {
    const availability = this.props.availability;
    const dateOptions = availability.dates || [];
    const selectedTab = this.state.selectedTab;
    const selectedSlot = this.props.slot;
    const selectedDate = this.props.date;
    const slots = []
      .concat(
        availability.immediate_delivery && this.dateIsToday(selectedTab)
          ? this.props.immediateSlot
          : []
      )
      .concat((selectedTab || {}).slots || []);
    const firstSlots = slots.slice(0, 5);
    const canViewMore = slots.length > firstSlots.length;
    const slotsExpanded = this.state.slotsExpanded;
    const slotOptions = slotsExpanded ? slots : firstSlots;
    const canSelectTime = !!dateOptions.length;

    return (
      <>
        <div
          className={classnames(flex, centerItems, {
            [margin.bottom_sm]: canSelectTime
          })}
        >
          <Icon />
          <Title />
        </div>

        {canSelectTime && (
          <form
            onSubmit={e => this.handleSubmit(e)}
            ref={form => (this.form = form)}
          >
            {this.state.error && (
              <div className="warning">{this.state.error}</div>
            )}

            <RadioList className={margin.bottom_sm}>
              <Tabs>
                {dateOptions.map(option => (
                  <Tab
                    key={option.date}
                    heading={this.dateIsToday(option) ? 'Today' : option.day}
                    subheading={moment(new Date(option.date)).format('MMM D')}
                    isSelected={option.date === selectedTab.date}
                    onClick={() => this.selectTab(option)}
                  />
                ))}
              </Tabs>

              {slotOptions.map(option => (
                <RadioListItem
                  key={option.description}
                  name="delivery-time"
                  id={`delivery-time_${option.description.replace(/\s/g, '')}`}
                  checked={
                    option.description === selectedSlot.description &&
                    selectedTab.date === selectedDate.date
                  }
                  onChange={() =>
                    this.selectSlot({ slot: option, date: selectedTab })
                  }
                  title={option.description}
                />
              ))}

              {canViewMore && (
                <SecondarySmall
                  tag="div"
                  className={`${textCenter} ${padding.sm}`}
                >
                  <TextButton
                    noUnderline
                    type="button"
                    onClick={
                      slotsExpanded
                        ? () => this.collapseSlots()
                        : () => this.expandSlots()
                    }
                  >
                    <span className={margin.right_xxs}>
                      {slotsExpanded ? 'View Fewer' : 'View All'}
                    </span>
                    {slotsExpanded ? <ChevronUp /> : <ChevronDown />}
                  </TextButton>
                </SecondarySmall>
              )}
            </RadioList>

            <div className="row">
              <div className="col-xs-12 col-md-5 col-md-offset-7 col-lg-4 col-lg-offset-8">
                <PrimaryButton type="submit" className={width100}>
                  Continue
                </PrimaryButton>
              </div>
            </div>
          </form>
        )}
      </>
    );
  }
}

const ConnectedExpanded = connect(
  state => ({
    availability: state.checkout.availability,
    date: state.checkout.deliveryDate,
    slot: state.checkout.deliveryTime,
    immediateSlot: state.checkout.immediateSlot
  }),
  { selectDeliveryTime, selectDeliveryDate }
)(Expanded);

export default ConnectedExpanded;
